import React, { useState, useEffect } from "react";

const Leaders = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const items = [
    {
      imageUrl: "assets/Leaders/PM-Modi.jpg",
      quote:
        "“I hope that <b>UDGAAR</b>, organised by its youth forum, will be an ideal platform for our youth to showcase their talents and to reaffirm their support for the progress of the nation.”",
      name: "Shri Narendra Modi",
      position: "Hon'ble Prime Minister of India",
    },
    {
      imageUrl: "assets/Leaders/Dr.Balram.jpg",
      quote:
        "“I am confident that this initiative by Ethiccraft Club in the college premises will surely help the students of the college to become empowered with wisdom.”",
      name: "Dr. Balram Pani",
      position: "Dean of colleges, University of Delhi",
    },
    {
      imageUrl: "assets/Leaders/Dr.-PB-Sharma.jpg",
      quote:
        '“I am happy that Ethiccraft Club is taking a step forward towards making India drug free with their "Building India Upon Values " initiative.”',
      name: "Dr. P.B. Sharma",
      position: "Former Vice Chancellor of Amity University, Manesar",
    },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % items.length);
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrev = () => {
    setActiveIndex((prevIndex) =>
      prevIndex === 0 ? items.length - 1 : prevIndex - 1,
    );
  };

  const handleNext = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  // Add keyboard navigation
  const handleKeyPress = (e) => {
    if (e.key === "ArrowLeft") {
      handlePrev();
    } else if (e.key === "ArrowRight") {
      handleNext();
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="Leaders_section">
      <div className="Leaders_slide leader-height">
        <div className="carousel-inner LL-size" role="listbox">
          {/* <h1>Our Leaders</h1> */}
          {items.map((item, index) => (
            <div
              key={index}
              className={`item ${index === activeIndex ? "active" : ""}`}
            >
              <div className="row">
                <div className="LL">
                  <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                    <div className="LL-img">
                      <img
                        src={item.imageUrl}
                        alt={item.name}
                        className="fade-in"
                      />
                    </div>
                  </div>
                  <div className="col-lg-9 col-md-9 col-sm-9 col-xs-12">
                    <div className="LL-text">
                      <p
                        className="para"
                        dangerouslySetInnerHTML={{ __html: item.quote }}
                      ></p>
                      <div className="mline"></div>
                      <h4 className="name">{item.name}</h4>
                      <h6>{item.position}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Leaders;
